
import { Routes, Route } from "react-router-dom";
import { datas } from "./data/data";
import { NavbarContextProvider } from "./context/navbar/NavbarContext";
import HomePage from "./pages/home/index";
import NavBar from "./components/reuseables/NavBar";
import About from "./pages/about/index";
import OurWorks from "./pages/our-works/index";
import NotFound from "./pages/not-found/index";
import ContactUs from "./pages/contact-us/index";
import WebPage from "./pages/web-page/index";
import PrivacyPolicy from "./pages/privacy-policy/index";
import "./App.css";
import AOS from "aos";
import "aos/dist/aos.css";

function App() {
  AOS.init();
  return (
    <NavbarContextProvider>
      <div className="App">
        <NavBar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/our-works" element={<OurWorks datas={datas} />} />
          <Route path="/our-works/:slug" element={<WebPage datas={datas} />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </NavbarContextProvider>
  );
}

export default App;
